// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CommunicationDirection,
    CommunicationDirectionFromJSON,
    CommunicationDirectionToJSON,
    CommunicationMethod,
    CommunicationMethodFromJSON,
    CommunicationMethodToJSON,
    CommunicationType,
    CommunicationTypeFromJSON,
    CommunicationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface GuarantorCommunication
 */
export interface GuarantorCommunication {
    /**
     * Communication id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {CommunicationType}
     * @type {CommunicationType}
     * @memberof GuarantorCommunication
     */
    communicationType?: CommunicationType;
    /**
     * 
     * OpenAPI data type: {CommunicationMethod}
     * @type {CommunicationMethod}
     * @memberof GuarantorCommunication
     */
    communicationMethod?: CommunicationMethod;
    /**
     * 
     * OpenAPI data type: {CommunicationDirection}
     * @type {CommunicationDirection}
     * @memberof GuarantorCommunication
     */
    communicationDirection?: CommunicationDirection;
    /**
     * Email used in communication
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    email?: string;
    /**
     * Phone used in communication
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    phone?: string;
    /**
     * Message contents if available
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    message?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof GuarantorCommunication
     */
    communicationDate?: string;
    /**
     * Patient tied to communication
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    patientId?: string;
    /**
     * Patient name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof GuarantorCommunication
     */
    patientName?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof GuarantorCommunication
     */
    attachmentDocumentIds?: Array<string>;
}

export function GuarantorCommunicationFromJSON(json: any): GuarantorCommunication {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'communicationType': !exists(json, 'communicationType') ? undefined : CommunicationTypeFromJSON(json['communicationType']),
            'communicationMethod': !exists(json, 'communicationMethod') ? undefined : CommunicationMethodFromJSON(json['communicationMethod']),
            'communicationDirection': !exists(json, 'communicationDirection') ? undefined : CommunicationDirectionFromJSON(json['communicationDirection']),
            'email': !exists(json, 'email') ? undefined : json['email'],
            'phone': !exists(json, 'phone') ? undefined : json['phone'],
            'message': !exists(json, 'message') ? undefined : json['message'],
            'communicationDate': !exists(json, 'communicationDate') ? undefined : json['communicationDate'],
            'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
            'patientName': !exists(json, 'patientName') ? undefined : json['patientName'],
            'attachmentDocumentIds': !exists(json, 'attachmentDocumentIds') ? undefined : json['attachmentDocumentIds'],
    };

}

export function GuarantorCommunicationToForm(value?: GuarantorCommunication): any {
    let jsonVal = GuarantorCommunicationToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function GuarantorCommunicationToJSON(value?: GuarantorCommunication): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'communicationType': CommunicationTypeToJSON(value.communicationType),
            'communicationMethod': CommunicationMethodToJSON(value.communicationMethod),
            'communicationDirection': CommunicationDirectionToJSON(value.communicationDirection),
            'email': cleanupBlankValuesForBackend(value.email),
            'phone': cleanupBlankValuesForBackend(value.phone),
            'message': cleanupBlankValuesForBackend(value.message),
            'communicationDate': cleanupBlankValuesForBackend(value.communicationDate),
            'patientId': cleanupBlankValuesForBackend(value.patientId),
            'patientName': cleanupBlankValuesForBackend(value.patientName),
            'attachmentDocumentIds': cleanupBlankValuesForBackend(value.attachmentDocumentIds),
    };
}


